import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePrivateRoutingDestinationsMutationVariables = Types.Exact<{
  destinations: Array<Types.InputMaybe<Types.DestinationModel>>;
}>;


export type UpdatePrivateRoutingDestinationsMutation = { __typename?: 'Mutation', updatePrivateRoutingDestinations?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } | null };


export const UpdatePrivateRoutingDestinationsDocument = gql`
    mutation updatePrivateRoutingDestinations($destinations: [DestinationModel]!) {
  updatePrivateRoutingDestinations(destinations: $destinations) {
    errors {
      location
      type
      context
    }
  }
}
    `;
export type UpdatePrivateRoutingDestinationsMutationFn = Apollo.MutationFunction<UpdatePrivateRoutingDestinationsMutation, UpdatePrivateRoutingDestinationsMutationVariables>;

/**
 * __useUpdatePrivateRoutingDestinationsMutation__
 *
 * To run a mutation, you first call `useUpdatePrivateRoutingDestinationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrivateRoutingDestinationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrivateRoutingDestinationsMutation, { data, loading, error }] = useUpdatePrivateRoutingDestinationsMutation({
 *   variables: {
 *      destinations: // value for 'destinations'
 *   },
 * });
 */
export function useUpdatePrivateRoutingDestinationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrivateRoutingDestinationsMutation, UpdatePrivateRoutingDestinationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrivateRoutingDestinationsMutation, UpdatePrivateRoutingDestinationsMutationVariables>(UpdatePrivateRoutingDestinationsDocument, options);
      }
export type UpdatePrivateRoutingDestinationsMutationHookResult = ReturnType<typeof useUpdatePrivateRoutingDestinationsMutation>;
export type UpdatePrivateRoutingDestinationsMutationResult = Apollo.MutationResult<UpdatePrivateRoutingDestinationsMutation>;
export type UpdatePrivateRoutingDestinationsMutationOptions = Apollo.BaseMutationOptions<UpdatePrivateRoutingDestinationsMutation, UpdatePrivateRoutingDestinationsMutationVariables>;